export default "__VITE_ASSET__X9JhkIM5__"